import { render, staticRenderFns } from "./DeadTime.vue?vue&type=template&id=15b8796b&scoped=true&"
import script from "./DeadTime.vue?vue&type=script&lang=js&"
export * from "./DeadTime.vue?vue&type=script&lang=js&"
import style0 from "./DeadTime.vue?vue&type=style&index=0&id=15b8796b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8796b",
  null
  
)

export default component.exports